module.exports = __webpack_public_path__ + "static/media/bg2.2e19c22e.jpg";